export default "__VITE_ASSET__DTD72QGK__"